import { SearchScenarioId } from 'owa-search-next';
import { lazyGetSearchBoxContent, lazyGetSearchStore } from 'owa-search-next-lazy';
import { SubstrateSearchSuggestionSegment } from 'owa-search-service';

export default async function getSuggestionQueryString(
    scenarioId: SearchScenarioId
): Promise<string> {
    const getSearchBoxContent = await lazyGetSearchBoxContent.import();
    const { text: searchBoxText } = getSearchBoxContent(scenarioId);

    // Get individual parts of query string (pills, segments, text).
    const suggestionSegmentsQueryString = await getSuggestionSegmentsQueryString(scenarioId);

    // Join parts (after removing empty strings) with spaces.
    return [suggestionSegmentsQueryString, searchBoxText]
        .filter((queryString: string) => queryString && queryString.length > 0)
        .join(' ');
}

// Gets the suggestion segment part of the query string to send for suggestions.
async function getSuggestionSegmentsQueryString(scenarioId: SearchScenarioId): Promise<string> {
    const getSearchStore = await lazyGetSearchStore.import();
    const suggestionSegments = getSearchStore(scenarioId).suggestionSegments;

    // If there are no suggestion segments, return null;
    if (suggestionSegments.size === 0) {
        return null;
    }

    return (
        [...suggestionSegments.values()]
            // Get text for segment based on segment type.
            .map((suggestionSegment: SubstrateSearchSuggestionSegment) => {
                switch (suggestionSegment.Type) {
                    case 'Text':
                        return suggestionSegment.Text;
                    case 'Person':
                        return suggestionSegment.DisplayName;
                    default:
                        return null;
                }
            })
            // Remove any null values (i.e. non-People suggestion pills).
            .filter(string => string)
            // Join strings with spaces.
            .join(' ')
    );
}
